import React from 'react';
import styled from 'styled-components';
import { ellipsis } from 'polished';
import { themeGet } from '@styled-system/theme-get';
import { Icon } from '../icon/Icon';

const StyledCardInfo = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 0;
  padding: 0;
  padding-top: 16px; /* workaround for flex not margin collapse */
  width: 100%;
  height: auto;
  align-items: center;
`;

const Text = styled.span`
  font-size: ${themeGet('cardInfo.fontSize')};
  color: ${themeGet('cardInfo.color')};
  margin-left: 4px;
`;

const Info = styled.li`
  ${ellipsis()}
  height: 20px;
  padding: 0 16px;
  margin-bottom: 16px;
`;

export const CardInfo = ({ data }) => (
  <StyledCardInfo>
    {data.map(info => (
      <Info key={info.icon_name}>
        <Icon name={info.icon_name} />
        <Text>{info.text}</Text>
      </Info>
    ))}
  </StyledCardInfo>
);
